/// <amd-module name="VC/Common/Components/HeaderComponents" />
import React = require("react");
import { VssComponent } from "VSS/Platform/Layout";
import { LegacyComponent } from "VSS/Legacy/Legacy";
import { CommandBarChildComponent , IComponentWithStateProps } from "VSS/Features/Frame/CommandBar";

export interface VersionControlActionHeaderComponentProps extends IComponentWithStateProps {
    /**
     * componentType to render
     */
    wrappedComponentType: string;

    /**
     * Indicates if the component is currently selected.
     */
    selected: boolean;
}

/**
 * This Component renders version control actions
 */
class VersionControlActionHeaderComponent extends VssComponent<VersionControlActionHeaderComponentProps, {}> {
    public static componentType = "versionControlActionHeader";

    public render(): JSX.Element {
        return (
            <CommandBarChildComponent {...this.props} noTabIndex={true}>
                <LegacyComponent
                    key={this.props.wrappedComponentType}
                    wrappedType={this.props.wrappedComponentType}
                    modules={["VersionControl/Scripts/Components/HeaderComponents/HeaderComponents"]}
                    selected={this.props.selected}
                />
            </CommandBarChildComponent>
        );
    }
}

// Register the header components with the layout manager
VssComponent.register(VersionControlActionHeaderComponent.componentType, VersionControlActionHeaderComponent);
